/* eslint-disable quotes */
/* eslint-disable react/prop-types */
/* eslint-disable react/jsx-no-bind */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable @scandipwa/scandipwa-guidelines/jsx-no-props-destruction */

// // eslint-disable-next-line quotes

// /** @namespace Mspwa/Component/BestSeller/BestSellerSlider/BestSellerSlider */

import SwiperCore, { Autoplay, Pagination } from "swiper";
import { Swiper, SwiperSlide } from "swiper/react";

import history from "Util/History";

import "swiper/swiper-bundle.css";

export function BestSellerSlide({ image, url }) {
    return (
    <div
      style={ {
          height: "auto"
      } }
      onClick={ () => {
          history.push(url);
      } }
    >
      <img src={ image } alt="" />
    </div>
    );
}

SwiperCore.use([Pagination, Autoplay]);

export default function BestSellerSlider({ bestSellers }) {
    return (
    <Swiper
      pagination
      style={ {
          borderRadius: "20px"
      } }
      autoplay={ {
          delay: 5000
      } }
      spaceBetween={ 50 }
      slidesPerView={ 1 }
    >
      { bestSellers.map((bs) => (
        <SwiperSlide key={ bs.id }>
          <BestSellerSlide { ...bs } />
        </SwiperSlide>
      )) }
    </Swiper>
    );
}
